import { z } from 'zod'

import {
  onDemandCourseProperties,
  learningItemProperties,
  learningPathProperties,
  scheduledCourseProperties,
  scheduledCourseEventProperties,
} from './BaseModels'
import { groupLearningAssignmentParser } from './GroupLearningAssignment'
import { learningItemPermissionsParser } from './Permissions'
import { sortBy } from 'lodash'

/**********************************************************************
 * baseLearningItemProperties
 **********************************************************************/
const baseLearningItemProperties = {
  ...learningItemProperties,
  groupLearningAssignments: z.array(groupLearningAssignmentParser).nullish(),
  overallCompletion: z.number().nullish(),
  permissions: learningItemPermissionsParser,
}

/**********************************************************************
 * OnDemandCourse
 **********************************************************************/
export const onDemandCourseParser = z.object({
  ...baseLearningItemProperties,
  kind: z.literal('onDemandCourse'),
  onDemandCourse: z.object(onDemandCourseProperties),
})

export type OnDemandCourse = z.infer<typeof onDemandCourseParser>

/**********************************************************************
 * LearningPath
 **********************************************************************/
export const learningPathParser = z.object({
  ...baseLearningItemProperties,
  kind: z.literal('learningPath'),
  learningPath: z.object({
    ...learningPathProperties,
  }),
})

export const scheduledCourseParser = z.object({
  ...baseLearningItemProperties,
  kind: z.literal('scheduledCourse'),
  scheduledCourse: z.object({
    ...scheduledCourseProperties,
    events: z.array(z.object(scheduledCourseEventProperties)).transform((e) => sortBy(e, 'startDate')),
  }),
})

/**********************************************************************
 * LearningItem
 **********************************************************************/
export const groupLearningItemParser = z.preprocess(
  (o: any) => {
    if (o) {
      o.kind = o?.onDemandCourseUuid ? 'onDemandCourse' : o?.scheduledCourseUuid ? 'scheduledCourse' : 'learningPath'
    }
    return o
  },
  z.discriminatedUnion('kind', [onDemandCourseParser, learningPathParser, scheduledCourseParser])
)

export type GroupLearningItem = z.infer<typeof groupLearningItemParser>
